import React, {Component} from "react";
import COUNTRIES from "../../constants/countries";
import ReCAPTCHA from "react-google-recaptcha";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Select from 'react-validation/build/select';
import Button from 'react-validation/build/button';
import validator from 'validator';
import Xhr from "../../helpers/Xhr";
import {LOCAL} from "../../constants/local";

class Register extends Component {
	state = {
		email       : '',
		password    : '',
		last_name   : '',
		first_name  : '',
		middle_name : '',
		country     : 'Беларусь',
		address     : '',
		acceptRules : false,
		recaptcha   : null,
		phone       : '',
		messages    : []
	};

	acceptRules() {
		this.setState({
			acceptRules : !this.state.acceptRules
		});
	}

	onCaptchaChange(response) {
		this.setState({
			recaptcha : response
		});
	}

	inputChange(e) {
		const value = e.target.value;
		const name = e.target.name;

		const stateChange = {[name] : value};
		this.setState({...this.state, ...stateChange});
	}

	errorBox(message) {
		return <div className="error">{message}</div>
	}

	required(value) {
		if ( validator.isEmpty(value) ) {
			return this.errorBox('Поле обязательно для заполнения!');
		}
	};

	email(value) {
		if ( !validator.isEmail(value) ) {
			return this.errorBox('Введите корректный E-mail!');
		}
	};

	password(value) {
		if ( value.toString().trim().length < 6 ) {
			return this.errorBox('Пароль должен быть не менее 6 символов!')
		}
	}

	fio(value) {
		if ( value.toString().trim().length < 2 ) {
			return this.errorBox('Не менее 2 символов!');
		}
	}

	phone(value) {
		if ( value.toString().trim().length > 0 && (value.toString().trim().length > 18 || value.toString().trim().length < 6) ) {
			return this.errorBox('От 6 до 18 символов!');
		}
	}

	onSubmit(event) {
		event.preventDefault();
		this.form.validateAll();
		const values = this.form.getValues();
		const data = {...values, currency : LOCAL.currency};

		Xhr.register(data).then((resp) => {
			if ( resp.code === 200 ) {
				const textSuccess = 'Ваш аккаунт успешно зарегистрирован. Для его активации пройдите по ссылке, отправленной на Ваш электронный адрес.';
				alert(textSuccess);

				this.setState({
					messages : [textSuccess]
				});
			}
			else {
				this.setState({
					messages : ['Ошибка']
				});
			}
		});
	}


	render() {
		const countries = COUNTRIES;
		return (
			<div className="register">
				<div className="register__title">Регистрация <img src="http://maxline.by/assets/images/18+.png" align="absmiddle"/>
				</div>
				<div className="register__data">
					<Form ref={c => { this.form = c }} onSubmit={this.onSubmit.bind(this)}>
						{/*E-mail*/}
						<div className="register__data-header">
							<label htmlFor="email">E-mail&nbsp;<span className="required">*</span></label>
						</div>
						<div className="register__data-input_row">
							<div className="data">
								<Input type="text"
								       name="email"
								       id="email"
								       validations={[this.required.bind(this), this.email.bind(this)]}
								       onChange={this.inputChange.bind(this)}/>
							</div>
							<div className="comment">На Ваш e-mail будет выслано письмо для активации аккаунта</div>
						</div>

						{/*Пароль*/}
						<div className="register__data-header"><label htmlFor="password">Пароль&nbsp;
							<span className="required">*</span></label></div>
						<div className="register__data-input_row">
							<div className="data">
								<Input type="password"
								       name="password"
								       id="password"
								       onChange={this.inputChange.bind(this)}
								       validations={[this.required.bind(this), this.password.bind(this)]}/>
							</div>
						</div>

						{/*Фамилия*/}
						<div className="register__data-header">
							<label htmlFor="lastname">Фамилия&nbsp;<span className="required">*</span></label>
						</div>
						<div className="register__data-input_row">
							<div className="data">
								<Input type="text"
								       id="lastname"
								       name="last_name"
								       onChange={this.inputChange.bind(this)}
								       validations={[this.required.bind(this), this.fio.bind(this)]}/>
							</div>
							<div className="comment">Для успешной идентификации личности при выплатах необходимы Ваши
								фамилия, имя и отчество полностью, на русском языке
							</div>
						</div>

						{/*Имя*/}
						<div className="register__data-header"><label htmlFor="firstname">Имя&nbsp;
							<span className="required">*</span></label>
						</div>
						<div className="register__data-input_row">
							<div className="data">
								<Input type="text"
								       id="firstname"
								       name="first_name"
								       onChange={this.inputChange.bind(this)}
								       validations={[this.required.bind(this), this.fio.bind(this)]}/>
							</div>
						</div>

						{/*Отчество*/}
						<div className="register__data-header">
							<label htmlFor="middlename">Отчество&nbsp;<span className="required">*</span></label>
						</div>
						<div className="register__data-input_row">
							<div className="data">
								<Input type="text"
								       id="middlename"
								       name="middle_name"
								       onChange={this.inputChange.bind(this)}
								       validations={[this.required.bind(this), this.fio.bind(this)]}/>
							</div>
						</div>

						{/*Страна*/}
						<div className="register__data-header">
							<label htmlFor="country">Страна&nbsp;<span className="required">*</span></label>
						</div>
						<div className="register__data-input_row">
							<div className="data">
								<Select id="country"
								        value={this.state.country}
								        name="country"
								        onChange={this.inputChange.bind(this)}
								        validations={[this.required.bind(this)]}>
									{countries.map((country, index) =>
										<option key={index} value={country}>{country}</option>)}
								</Select>
							</div>
						</div>

						{/*Город*/}
						<div className="register__data-header">
							<label htmlFor="city">Город&nbsp;<span className="required">*</span></label>
						</div>
						<div className="register__data-input_row">
							<div className="data">
								<Input
									type="text" id="city" name="address" onChange={this.inputChange.bind(this)}
									validations={[this.required.bind(this)]}/>
							</div>
						</div>

						{/*Мобила*/}
						<div className="register__data-header">
							<label htmlFor="phone">Номер телефона</label>
						</div>
						<div className="register__data-input_row">
							<div className="data">
								<Input
									type="text" id="phone" name="phone" onChange={this.inputChange.bind(this)}
									validations={[this.phone.bind(this)]}/>
							</div>
						</div>

						<div className="register__data-input_row">
							<div className="data checkbox accept-rules">
								<input type="checkbox"
								       name="acceptRules"
								       id="acceptRules"
								       checked={this.state.acceptRules}
								       onChange={this.acceptRules.bind(this)}/>

								<label htmlFor="acceptRules">
									&nbsp;Я подтверждаю достоверность указанных мною данных.<br/>
									Согласен с условиями и принимаю&nbsp;«Правила приема ставок»
								</label>
							</div>
						</div>

						<div className="register__data-captcha">
							<p>
								<ReCAPTCHA sitekey="6LduCJsUAAAAAGT_AbO3gVsz2_jzKHDD7VuonbCN"
								           ref="recaptcha"
								           onChange={this.onCaptchaChange.bind(this)}/>
							</p>
						</div>

						{/*<div className="register__data-warning">*/}
							{/*<strong>Внимание!</strong>*/}
							{/*<div>*/}
								{/*Для получения возможности совершать игровые и денежные операции,*/}
								{/*после регистрации необходимо выслать сканы (фото) 31-й и 33-й страниц паспорта*/}
								{/*(для иностранных граждан - страница с серией и номером паспорта, страница с*/}
								{/*регистрацией)*/}
								{/*на <a href="mailto:support@maxline.by">passport@maxline.by</a> либо загрузить их в*/}
								{/*личном кабинете в разделе "Загрузить документ"*/}
							{/*</div>*/}
						{/*</div>*/}

						<div className="register__data-buttons buttons">
							{/*disabled={!this.state.acceptRules || this.state.recaptcha === null}*/}
							{this.state.acceptRules && this.state.recaptcha !== null && <Button className="buttons__show">Зарегистрироваться</Button>}

							<div className="register__data-messages">
								{this.state.messages}
							</div>
						</div>
					</Form>
				</div>
			</div>
		)
	}
}

export default Register;


// WEBPACK FOOTER //
// ./src/app/pages/Auth/Register.js